import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  home: "/",
  winningAds: "/winning-ads",
  orders: "/orders",
  sampleOrders: "/sample-orders",
  customization: "/customization",
  importList: "/import-list",
  liveProducts: "/live-products",
  brandedInvoice: "/branded-invoice",
  promoReviews: "/reviewspro",
  cancel: "/cancel",
  findProducts: "/find-products",
};
